module.exports = "/fonts/Cabin-Regular.ttf";